exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table th[data-v-bdc95796], .table td[data-v-bdc95796] {\n    padding: 5px .75rem;\n}\n", ""]);

// exports
